import UserAccessDto from '@/features/auth/login/types/UserAccessDto';
import { MyAccessDto } from '../types/MyAccessDto';

// Tymczasowy shim: stary backend zwraca z /access samą tablicę dostępów, a frontend może
// wejść na produkcję pierwszy. Usunąć, gdy obie strony będą wdrożone.
export const normalizeMyAccess = (
  raw: MyAccessDto | UserAccessDto[],
): MyAccessDto =>
  Array.isArray(raw) ? { accesses: raw, invitations: [] } : raw;
